import React from "react";
import { useTranslation } from "react-i18next";
import style from "../partnerProfileModal.module.scss";
import CustomButton from "../../../../custom/custom-button/CustomButton";

const PartnerActions = ({ item, onConfirm, onReject, isConfirmLoading, isRejectLoading }) => {
  const { t } = useTranslation();

  if (item.state !== "Moderation") {
    return null;
  }

  return (
    <>
      <div className={style.decision}>
        <h3>{t("partnerProfile.decision.title")}</h3>
      </div>

      <div className={style.actions}>
        <CustomButton
          text={t("partnerProfile.decision.approve")}
          onClick={onConfirm}
          isLoading={isConfirmLoading}
          isDark
        />
        <CustomButton
          text={t("partnerProfile.decision.reject")}
          onClick={onReject}
          isLoading={isRejectLoading}
          isWhiteBox
        />
      </div>
    </>
  );
};

export default PartnerActions;
